import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export default function Account() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ name: user.name || "", phone: user.phone || "" });
  const [busy, setBusy] = useState(false);
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const next = params.get("next");
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/auth/profile", form);
      setUser(data);
      toast.success("Your details are saved.");
      if (next) navigate(next, { replace: true });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  const a = user.shipping_address;
  return (
    <div className="mx-auto max-w-2xl px-4 py-12" data-testid="account-page">
      <h1 className="text-4xl font-bold text-[#4A2A18]">{next ? "One more step" : "Your account"}</h1>
      {next && <p className="mt-3 text-lg text-[#5C4A3E]" data-testid="account-phone-needed">Please add your phone number so we can reach you about your order. Then we'll take you right back.</p>}
      <form onSubmit={save} className="paper-card mt-8 space-y-5 p-6 sm:p-8">
        <div><label className="label" htmlFor="acc-name">Full name</label><input id="acc-name" className="field" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="account-name-input" required /></div>
        <div><label className="label">Email</label><p className="text-lg text-[#4A3B32]" data-testid="account-email">{user.email}</p></div>
        <div><label className="label" htmlFor="acc-phone">Phone number</label><input id="acc-phone" type="tel" className="field" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="account-phone-input" required minLength={7} /></div>
        <div><label className="label">Shipping address</label><p className="text-lg text-[#4A3B32]" data-testid="account-address">{a ? `${a.name}, ${a.line1}${a.line2 ? ", " + a.line2 : ""}, ${a.city}, ${a.state} ${a.zip}` : "Added when you place your first order."}</p></div>
        <button className="btn-primary w-full" disabled={busy} data-testid="account-save-button">{next ? "Save and continue" : "Save my details"}</button>
      </form>
    </div>
  );
}
